module.exports = __webpack_public_path__ + "static/media/organizer_11.f421e070.jpg";